// enodePlugin.js

import enodeLib from 'enode-lib'
import config from '@/config/config.app.json'
import Vue from 'vue'

let instance = null;

export function createEnodeLib(startTimer) {
    if (!instance) {
        console.log('Starting Enode Lib...');
        let rhRequest = Vue.prototype.$rhRequest
        instance = new enodeLib(rhRequest, config)

        if (Vue.prototype.$rhAuth.loggedIn() && Object.hasOwn(config, 'enodeRedirect')) {
            instance.getData()
        }

        if(startTimer && Object.hasOwn(config, 'enodeRedirect')) {
            // startTimer, that calls enodePlugin.getData every 10 seconds
            setInterval(() => {
                if (Vue.prototype.$rhAuth.loggedIn()) {
                    instance.getData()
                }
            }, 10000)
        }
    }
    return instance;
}